// Niveles maximos que soporta el visor del libro: los agrupadores se navegan hasta el nivel 4 y el
// nivel 5 es la ultima columna, donde unicamente se muestran umas (nunca agrupadores).
const NIVEL_MAXIMO_AGRUPADOR = 4;
const NIVEL_MAXIMO_UMA = 5;

const obtenerUltimoOrden = (contenidos, contenido) => {
    let ultimoOrden = contenidos.filter((contenidoHijo) => contenidoHijo.padre === contenido._id).sort((a, b) => a.orden - b.orden);
    ultimoOrden = ultimoOrden.length > 0 ? ultimoOrden[ultimoOrden.length - 1].orden : 0;
    return ultimoOrden;
};

const obtenerRecorridoAgrupador = (contenidos, contenidoActual) => {
    let raizContenidos = contenidos.find(contenido => contenido.nivel === 1);
    let recorrido = [];
    let contenidoPadre = contenidoActual;
    while(contenidoPadre._id !== raizContenidos._id){
        recorrido.unshift(contenidoPadre);
        contenidoPadre = contenidos.find(contenido => contenido._id === contenidoPadre.padre);
    }
    return recorrido;
};

const obtenerRecorridoDescendenteAgrupador = (contenidos) => {
    if (!contenidos || !contenidos.hijos || contenidos.hijos.length === 0) {
        return 1;
    }
    let recorridoMaximo = 0;
    for (const contenido of contenidos.hijos) {
        const recorridoHijo = obtenerRecorridoDescendenteAgrupador(contenido);
        recorridoMaximo = Math.max(recorridoMaximo, recorridoHijo);
    }
    return recorridoMaximo + 1;
};

// Igual que obtenerRecorridoDescendenteAgrupador pero ignorando las umas: devuelve cuantos niveles de
// agrupadores ocupa el subarbol (1 = el agrupador solo, sin agrupadores hijos).
const obtenerRecorridoDescendenteSoloAgrupadores = (contenidos) => {
    if (!contenidos || !contenidos.hijos || contenidos.hijos.length === 0) {
        return 1;
    }
    let recorridoMaximo = 0;
    for (const contenido of contenidos.hijos) {
        if (contenido.uma) continue;
        const recorridoHijo = obtenerRecorridoDescendenteSoloAgrupadores(contenido);
        recorridoMaximo = Math.max(recorridoMaximo, recorridoHijo);
    }
    return recorridoMaximo + 1;
};

const organizarContenidosVisor = (contenidosCompletos, contenidos = [], primerNivel = true) => {
    if(contenidos.length === 0 && primerNivel){
        contenidos = contenidosCompletos.filter(contenido => contenido.nivel === 1);
    }
    const contenidosVisor = contenidos.reduce((acc, contenido) => {
        let contenidosHijos = contenidosCompletos.filter(contenidoHijo => contenidoHijo.padre === contenido._id)
        if(contenidosHijos.length === 0 && contenido.uma) return [...acc, contenido];
        else if(contenidosHijos.length === 0){
            let bodyContenido = {
                ...contenido,
                hijos: []
            };
            return [...acc, bodyContenido];
        }
        let bodyContenido = {
            ...contenido,
            hijos: organizarContenidosVisor(contenidosCompletos, contenidosHijos),
        };
        return [...acc, bodyContenido];
    }, []);
    return contenidosVisor;
};

const organizarContenidosVisorEscaparate = (contenidos) => {
    const obtenerEstructura = (padres, hijos) => {
        return padres.map(padre => {
            let hijosDirectos = hijos.filter(hijo => hijo.padre?.toString() === padre._id.toString());
            return {
                ...padre,
                hijos: obtenerEstructura(hijosDirectos, hijos)
            };
        });
    };
    
    const padres = contenidos.filter(x => x.padre === undefined);
    const hijos = contenidos.filter(x => x.padre !== undefined);
    const arrPadres = obtenerEstructura(padres, hijos);
    return arrPadres;
};

const subirContenido = (contenidos, contenido) => {
    let contenidosHijos = contenidos.filter(contenidoHijo => contenidoHijo.padre === contenido.padre).sort((a, b) => a.orden - b.orden);
    let indexHijo = contenidosHijos.findIndex(contenidoHijo => contenidoHijo._id === contenido._id);
    let newContenidos = contenidos.map(contenido => {
        if(contenido._id === contenidosHijos[indexHijo]._id){
            return {
                ...contenido,
                orden: contenidosHijos[indexHijo - 1].orden,
            };
        } else if (contenido._id === contenidosHijos[indexHijo - 1]._id){
            return {
                ...contenido,
                orden: contenidosHijos[indexHijo].orden,
            };
        }
        return contenido;
    });
    return newContenidos;
};

const bajarContenido = (contenidos, contenido) => {
    let contenidosHijos = contenidos.filter(contenidoHijo => contenidoHijo.padre === contenido.padre).sort((a, b) => a.orden - b.orden);
    let indexHijo = contenidosHijos.findIndex(contenidoHijo => contenidoHijo._id === contenido._id);
    let newContenidos = contenidos.map(contenido => {
        if(contenido._id === contenidosHijos[indexHijo]._id){
            return {
                ...contenido,
                orden: contenidosHijos[indexHijo + 1].orden,
            };
        } else if (contenido._id === contenidosHijos[indexHijo + 1]._id){
            return {
                ...contenido,
                orden: contenidosHijos[indexHijo].orden,
            };
        }
        return contenido;
    });
    return newContenidos;
};

// Reordena un contenido dentro de sus hermanos (mismo padre, mismo nivel). Los indices son
// posiciones dentro de la lista de hermanos ya ordenada por orden, tal como se muestra en la tabla.
const reordenarContenidos = (contenidos, padreId, indexOrigen, indexDestino) => {
    if(indexOrigen === indexDestino) return contenidos;
    let contenidosHijos = contenidos
        .filter(contenidoHijo => String(contenidoHijo.padre) === String(padreId))
        .sort((a, b) => a.orden - b.orden);
    if(indexOrigen < 0 || indexOrigen >= contenidosHijos.length) return contenidos;
    if(indexDestino < 0 || indexDestino >= contenidosHijos.length) return contenidos;
    // Se reutilizan los valores de orden que ya existian y solo se redistribuyen entre los hermanos:
    // el orden puede traer huecos (al eliminar no se compacta) y renumerar marcaria como modificados
    // contenidos que nadie movio.
    let ordenes = contenidosHijos.map(contenidoHijo => contenidoHijo.orden);
    let [contenidoMovido] = contenidosHijos.splice(indexOrigen, 1);
    contenidosHijos.splice(indexDestino, 0, contenidoMovido);
    let ordenPorId = {};
    contenidosHijos.forEach((contenidoHijo, index) => {
        ordenPorId[contenidoHijo._id] = ordenes[index];
    });
    return contenidos.map(contenido => ordenPorId[contenido._id] !== undefined
        ? { ...contenido, orden: ordenPorId[contenido._id] }
        : contenido);
};

// Recalcula el nivel de cada contenido según su profundidad real recorriendo la cadena de padres
// desde la raíz. Evita que queden niveles desfasados (que el escaparate filtra por nivel y oculta).
const recalcularNiveles = (contenidos) => {
    // La raíz es el único contenido sin padre; los huérfanos (padre apuntando a un id inexistente) se ignoran.
    let raiz = contenidos.find(contenido => contenido.padre === undefined || contenido.padre === null)
        || contenidos.find(contenido => contenido.nivel === 1);
    if(!raiz) return contenidos;
    let nivelPorId = { [raiz._id]: raiz.nivel || 1 };
    const asignarHijos = (padreId) => {
        contenidos
            .filter(contenidoHijo => String(contenidoHijo.padre) === String(padreId))
            .forEach(hijo => {
                nivelPorId[hijo._id] = nivelPorId[padreId] + 1;
                asignarHijos(hijo._id);
            });
    };
    asignarHijos(raiz._id);
    return contenidos.map(contenido => nivelPorId[contenido._id] !== undefined
        ? { ...contenido, nivel: nivelPorId[contenido._id] }
        : contenido);
};

const eliminarContenido = (contenidos, contenido) => {
    // Hijos directos del agrupador eliminado: se reubican como hijos del padre del agrupador
    let idsHijosDirectos = contenidos
        .filter(contenidoHijo => String(contenidoHijo.padre) === String(contenido._id))
        .map(contenidoHijo => contenidoHijo._id);
    // El orden continúa al final de la lista de hijos del padre destino para no colisionar
    let ultimoOrden = obtenerUltimoOrden(contenidos, { _id: contenido.padre });
    let newContenidos = contenidos.map(contenidoHijo => {
        if(idsHijosDirectos.includes(contenidoHijo._id)){
            return {
                ...contenidoHijo,
                orden: ++ultimoOrden,
                padre: contenido.padre,
            };
        }
        return contenidoHijo;
    })
    newContenidos = newContenidos.filter(contenidoHijo => String(contenidoHijo._id) !== String(contenido._id));
    // Recalcula niveles: los hijos directos suben de nivel y todo su subárbol (nietos, etc.) también
    return recalcularNiveles(newContenidos);
};

const agregarContenido = (contenidos, contenido, contenidoPadre, origen) => {
    let padre = contenidoPadre === '' 
        ? contenidos.find(contenidoHijo => contenidoHijo.nivel === 1) 
        : contenidos.find(contenidoHijo => contenidoHijo._id === contenidoPadre);
    let ultimoOrden = obtenerUltimoOrden(contenidos, padre);
    let newContenido = {        
        _id: contenido._id,
        origen: origen.origen,
        id_origen: origen.id_origen,
        titulo: "agrupador",
        uma: {
            _id: contenido._id,
            autores: contenido.autores,
            descripcion: contenido.descripcion,
            esEliminado: contenido.esEliminado,
            materia: contenido.materia,
            esLiberada: contenido.esLiberada,
            origen: contenido.origen,
            titulo: contenido.titulo,
        },
        padre: padre._id,
        nivel: padre.nivel + 1,
        orden: ++ultimoOrden,
        esNuevo: true,
    };
    return [...contenidos, newContenido];
};

const agregarContenidos = (contenidos, contenidosSeleccionados, contenidoPadre, origen) => {
    let padre = contenidoPadre === '' 
        ? contenidos.find(contenidoHijo => contenidoHijo.nivel === 1) 
        : contenidos.find(contenidoHijo => contenidoHijo._id === contenidoPadre);
    let ultimoOrden = obtenerUltimoOrden(contenidos, padre);
    let newContenidos = contenidosSeleccionados.map(contenido => {
        let newContenido = {        
            _id: contenido._id,
            origen: origen.origen,
            id_origen: origen.id_origen,
            titulo: "agrupador",
            uma: {
                _id: contenido._id,
                autores: contenido.autores,
                descripcion: contenido.descripcion,
                esEliminado: contenido.esEliminado,
                materia: contenido.materia,
                esLiberada: contenido.esLiberada,
                origen: contenido.origen,
                titulo: contenido.titulo,
            },
            padre: padre._id,
            nivel: padre.nivel + 1,
            orden: ++ultimoOrden,
            esNuevo: true,
        };
        return newContenido;
    });
    return [...contenidos, ...newContenidos];
};

const moverContenido = (contenidos, agrupadorObj, contenido) => {
    if(contenido.uma){
        let ultimoOrden = obtenerUltimoOrden(contenidos, agrupadorObj);
        let newContenidos = contenidos.map(contenidoHijo => {
            if(contenidoHijo._id === contenido._id){
                return {
                    ...contenidoHijo,
                    padre: agrupadorObj._id,
                    nivel: agrupadorObj.nivel === 1 ? 2 : agrupadorObj.nivel + 1,
                    orden: ++ultimoOrden,
                };
            }
            return contenidoHijo;
        });
        return {contenidos: recalcularNiveles(newContenidos), mensaje: ''};
    }
    let recorridoAgrupador = obtenerRecorridoAgrupador(contenidos, agrupadorObj); //Obtener recorrido del agrupador seleccionado desde su posicion hasta la raiz
    let contenidoHijos = contenidos.filter(contenidoHijo => contenidoHijo.padre === contenido._id);
    let recorridoContenido = organizarContenidosVisor(contenidos, contenidoHijos, false);
    recorridoContenido = [{
        ...contenido,
        hijos: recorridoContenido,
    }];
    let arbolContenido = recorridoContenido[0];
    recorridoContenido = obtenerRecorridoDescendenteAgrupador(arbolContenido);
    let recorridoContenidoAgrupadores = obtenerRecorridoDescendenteSoloAgrupadores(arbolContenido);
    if(recorridoAgrupador.length >= 3){ //Verificar si el agrupador a mover no excede el nivel permitido
        return {contenidos: contenidos, mensaje: 'No es posible agregar agrupadores en el agrupador seleccionado'};
    }
    // Nivel en el que quedaria el agrupador movido: la raiz es el nivel 1 y el recorrido no la incluye
    let nivelAgrupadorMovido = recorridoAgrupador.length + 2;
    //Verificar que los agrupadores del agrupador a mover no bajen del nivel maximo permitido para agrupadores
    if(nivelAgrupadorMovido + recorridoContenidoAgrupadores - 1 > NIVEL_MAXIMO_AGRUPADOR){
        return {contenidos: contenidos, mensaje: 'Los agrupadores del agrupador a mover exceden el nivel de agrupadores permitido para el agrupador seleccionado'};
    }
    //Verificar si los contenidos del agrupador a mover no exceden el nivel permitido
    if(nivelAgrupadorMovido + recorridoContenido - 1 > NIVEL_MAXIMO_UMA){
        return {contenidos: contenidos, mensaje: 'Los contenidos del agrupador a mover excede el nivel de contenidos permitido para el agrupador seleccionado'};
    }
    let ultimoOrden = obtenerUltimoOrden(contenidos, agrupadorObj);
    let newContenidos = contenidos.map(contenidoHijo => {
        if(contenidoHijo._id === contenido._id){
            return {
                ...contenidoHijo,
                padre: agrupadorObj._id,
                nivel: agrupadorObj.nivel === 1 ? 2 : agrupadorObj.nivel + 1,
                orden: ++ultimoOrden,
            };
        }
        return contenidoHijo;
    });
    return {contenidos: recalcularNiveles(newContenidos), mensaje: ''};

};

const moverContenidos = (contenidos, agrupadorObj, contenidosSeleccionados) => {
    let nuevosContenidos = contenidos;
    let mensajes = [];
    let movidos = 0;
    contenidosSeleccionados.forEach((contenido) => {
        // Saltar los contenidos que ya están en el agrupador destino o que son el mismo agrupador destino
        if(contenido.padre === agrupadorObj._id || contenido._id === agrupadorObj._id){
            return;
        }
        let { contenidos: resultado, mensaje } = moverContenido(nuevosContenidos, agrupadorObj, contenido);
        if(mensaje !== ''){
            let titulo = contenido.uma ? contenido.uma.titulo : contenido.titulo;
            mensajes.push(`${titulo}: ${mensaje}`);
            return;
        }
        nuevosContenidos = resultado;
        movidos++;
    });
    return { contenidos: nuevosContenidos, mensajes, movidos };
};

const habilitarBtnGuardarLibro = (libroOriginal, libroModificado, contenidosApagadosOriginal, contenidosApagados) => {
    if(!libroOriginal || !libroModificado || !contenidosApagados || !contenidosApagadosOriginal) return false;
    if(libroOriginal.length > libroModificado.length || libroOriginal.length < libroModificado.length || contenidosApagadosOriginal.length > contenidosApagados.length || contenidosApagadosOriginal.length < contenidosApagados.length){
        return true;
    }
    let nuevosContenidosApagados = contenidosApagados.some(contenidoApagado => contenidoApagado._id === "crearEncenderApagar");
    if(nuevosContenidosApagados) return true;
    let atributosCambiados = false;
    libroOriginal.forEach(contenido => {
        if(atributosCambiados) return;
        let { nivel, orden, padre, titulo } = contenido;
        let contenidoModificado = libroModificado.find(contenidoModificado => contenidoModificado._id === contenido._id);
        if(!contenidoModificado){
            atributosCambiados = true;
            return;
        }
        if(nivel !== contenidoModificado.nivel || orden !== contenidoModificado.orden || padre !== contenidoModificado.padre || titulo !== contenidoModificado.titulo){
            atributosCambiados = true;
        }
    });
    if(atributosCambiados) return atributosCambiados;
    contenidosApagadosOriginal.forEach(contenido => {
        if(atributosCambiados) return;
        let { apagar } = contenido;
        let contenidoModificado = contenidosApagados.find(contenidoModificado => contenidoModificado._id === contenido._id);
        if(apagar !== contenidoModificado.apagar){
            atributosCambiados = true;
        }
    });
    return atributosCambiados;
}

const encenderApagarContenido = (contenidosApagados, contenido, libro, user) => {
    let encenderContenido = contenidosApagados.find(contenidoApagado => contenidoApagado.uma._id === contenido.uma._id);
    if(!encenderContenido){
        let newContenidoApagado = {
            plantel: user.escuela.campus._id,
            libro: libro._id,
            uma: contenido.uma,
            apagar: true,
            _id: "crearEncenderApagar",
        };
        return [...contenidosApagados, newContenidoApagado];
    }
    if(encenderContenido._id === "crearEncenderApagar"){
        let newContenidosApagados = contenidosApagados.filter(contenidoApagado => contenidoApagado.uma._id !== contenido.uma._id);
        return newContenidosApagados;
    }
    let newContenidosApagados = contenidosApagados.map(contenidoApagado => {
        if(contenidoApagado.uma._id === contenido.uma._id){
            return {
                ...contenidoApagado,
                apagar: !contenidoApagado.apagar,
            };
        }
        return contenidoApagado;
    });
    return newContenidosApagados;
};

const cambiarNombreAgrupador = (contenidos, agrupadorObj, nombre) => {
    let newContenidos = contenidos.map(contenido => {
        if(contenido._id === agrupadorObj){
            return {
                ...contenido,
                titulo: nombre,
            };
        }
        return contenido;
    });
    return newContenidos;
};

const actualizarLibro = (contenidosLibro) => {
    let newContenidosLibro = contenidosLibro.map(contenido => {
        if(!contenido.uma){
            return contenido;
        }
        return {
            ...contenido,
            uma: {
                _id: contenido.uma._id,
                autores: contenido.uma.autores,
            }
        };
    });
    return newContenidosLibro;
}

export {
    organizarContenidosVisor,
    subirContenido,
    bajarContenido,
    reordenarContenidos,
    eliminarContenido,
    agregarContenido,
    agregarContenidos,
    moverContenido,
    moverContenidos,
    obtenerUltimoOrden,
    habilitarBtnGuardarLibro,
    encenderApagarContenido,
    actualizarLibro,
    cambiarNombreAgrupador,
    organizarContenidosVisorEscaparate,
}